import React from 'react';
import { SkeletonComponent } from '@design-system';

export const OrderCartSkeleton: React.FC = () => {
    return (
        <div>
            <SkeletonComponent
                count={1}
                style={{
                    height: '87px',
                    width: '100%',
                    display: 'block'
                }}
            />
            {[...Array(3)].map((_, index) => (
                <SkeletonComponent
                    key={index}
                    count={1}
                    style={{
                        height: '220px',
                        width: 'calc(100% - 32px)',
                        margin: '0 auto',
                        borderRadius: '18px',
                        display: 'block'
                    }}
                    className="mt-medium-spacing"
                />
            ))}
        </div>
    );
};
